export default {"src":"/_next/static/media/extra-revisions.b5480d5d.svg","height":19,"width":21,"blurWidth":0,"blurHeight":0};